//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import { Omnichannel } from './libs/omnichannel'

const { header } = wcs.getStoreConfig()

export default {
  name: 'rb-header-omnichannel',
  computed: {
    ...mapGetters(['translation']),
    services() {
      return header?.omnichannel ? Omnichannel.mapOmnichannelFromStoreconf(header?.omnichannel) : []
    },
  },
}
